import React from 'react';
import { Link } from 'react-router-dom';

/** GOVOPS-1125 — Visible pilot outreach block on signed-in dashboards. */
const PilotOutreachBanner = () => (
  <section className="rhs-card rhs-pilot-outreach-banner" aria-labelledby="pilot-outreach-heading">
    <h2 id="pilot-outreach-heading" className="rhs-card-title">
      Pilot demo &amp; outreach
    </h2>
    <p className="rhs-muted rhs-card-lead">
      Share the public demo page or open the 5-minute presenter deck before a live walkthrough.
      Live operational data on this dashboard requires authorized access.
    </p>
    <div className="rhs-pilot-demo-cta">
      <Link to="/demo" className="rhs-btn rhs-btn--primary">
        Pilot demo overview
      </Link>
      <a
        href="/pilot-deck.html"
        target="_blank"
        rel="noopener noreferrer"
        className="rhs-btn rhs-btn--secondary"
      >
        Presenter deck
      </a>
    </div>
  </section>
);

export default PilotOutreachBanner;
